import "./home.css";

import React from "react";

import { CONTACT_DETAILS, HOME } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { LinkButton, PhotoStrip } from "../general/PageSections";
import Testimonials from "../general/Testimonials";

//Tripadvisor's own "Recommended on Tripadvisor" badge, as embedded on Wix. Their script registers a function that swaps
//the plain linked logo in the box for the green badge, but only runs it on window.onload - which has long gone by in a
//single-page app - so we run the function it registers ourselves once the script arrives (again on every visit to the page).
//The box's contents are set as raw HTML so React doesn't trip over Tripadvisor replacing them
const TA_UNIQ = "245";
const TA_FALLBACK = `<ul class="TA_links"><li><a target="_blank" rel="noopener noreferrer" href="${CONTACT_DETAILS.TRIPADVISOR_LINK}"><img src="https://www.tripadvisor.com/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor"/></a></li></ul>`;
const TripadvisorBadge = () => {
  React.useEffect(() => {
    const before = window.taValIndex || 0;
    const script = document.createElement("script");
    script.src = `https://www.tripadvisor.com/WidgetEmbed-rated?lang=en_US&locationId=${CONTACT_DETAILS.TRIPADVISOR_LOCATION_ID}&display_version=2&uniq=${TA_UNIQ}`;
    script.async = true;
    script.onload = () => {
      for (let i = before; i < (window.taValIndex || 0); i++) {
        try {
          window.taValList[i]();
        }
        catch (e) {
          //Leave the plain linked logo in place
        }
      }
    };
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <div
      id={`TA_rated${TA_UNIQ}`}
      className={"TA_rated tripadvisor-badge"}
      dangerouslySetInnerHTML={{ __html: TA_FALLBACK }}
    />
  );
};

//Three white cards over a photo
const CardBand = ({ cards, image }) => (
  <section
    className={"card-band"}
    style={{ backgroundImage: `url(${image})` }}
  >
    <div className={"card-grid container"}>
      {cards.map((card) => (
        <article
          key={card.title.join(" ")}
          className={"card"}
        >
          <h2 className={"card-title"}>
            {card.title.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
          <p className={"card-text"}>{card.text}</p>
          <hr className={"card-rule"} />
          <LinkButton
            path={card.link.path}
            href={card.link.href}
            className={"card-link"}
          >
            {card.link.label}
          </LinkButton>
        </article>
      ))}
    </div>
  </section>
);

const Home = () => {
  return (
    <React.Fragment>
      <PageMeta
        title={HOME.TITLE}
        isFullTitle
      />

      <section className={"home-hero"}>
        <img
          src={"/images/home/hero.webp"}
          alt={""}
          className={"home-hero-image"}
        />
        <h1 className={"home-hero-title"}>{HOME.HERO}</h1>
      </section>

      <section className={"home-intro"}>
        <div className={"container"}>
          <p className={"statement-text"}>{HOME.INTRO}</p>
          <div className={"home-badges"}>
            <a
              href={CONTACT_DETAILS.AFRISTAY_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/images/badges/travellers-choice.png"}
                alt={"Travellers' Choice - Dikalo Highston on AfriStay"}
                width={220}
                height={148}
                className={"is-travellers-choice"}
                loading={"lazy"}
              />
            </a>
            <img
              src={"/images/badges/4-stars.png"}
              alt={"4-star graded guesthouse"}
              width={480}
              height={152}
              className={"is-stars"}
              loading={"lazy"}
            />
            <TripadvisorBadge />
            {/* Linked to the AfriStay listing, as on Wix */}
            <a
              href={CONTACT_DETAILS.AFRISTAY_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/images/badges/fedhasa.png"}
                alt={"Member of FEDHASA - Dikalo Highston on AfriStay"}
                width={490}
                height={122}
                className={"is-fedhasa"}
                loading={"lazy"}
              />
            </a>
          </div>
        </div>
      </section>

      <CardBand
        cards={HOME.CARDS}
        image={"/images/home/rooms-bg.webp"}
      />

      <Testimonials
        title={HOME.TESTIMONIALS_TITLE}
        items={HOME.TESTIMONIALS}
      />

      <CardBand
        cards={HOME.CARDS_2}
        image={"/images/home/drinks-bg.webp"}
      />

      <section className={"statement"}>
        <div className={"container"}>
          <p className={"statement-text"}>{HOME.OUTRO}</p>
        </div>
      </section>

      <PhotoStrip src={"/images/events/event-table.webp"} />

      <section className={"statement"}>
        <div className={"container"}>
          <p className={"statement-text"}>
            {HOME.QUOTE} {HOME.QUOTE_BY}
          </p>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Home;
